import React, {useState, useEffect} from 'react'
import { Typeahead } from 'react-bootstrap-typeahead';
import { Link } from 'react-router-dom';
import AuditGroup from '../Audits/AuditGroup';
import Modal from '../Common Components/Modal';
import { TENANTS } from '../constants/AdtechConstants';
import { storeClientNameInMemory } from '../utils/adtech.utils';
import { getOfferIdsList, deleteOfferId, getBlackListedOfferIdsAuditsById } from './offerIds.service';

function ViewBlackListedOfferIds() {
  const [adsOfferIdBlacklistedList, setAdsOfferIdBlacklistedList] = useState([]);
  const [response, setResponse] = useState({ msg: "", isError: false });
  const [offerId, setOfferId] = useState("");
  const [offerIdsList, setOfferIdsList] = useState([]);
  const [clientNameList, setClientNameList] = useState([]);
  const [clientName, setClientName] = useState("")



  const [modal, setModal] = useState({
    isOpen : false,
    content : null,
    title : '',
    didMount : null,
    flatten : false
  })


  const cellStyle = {
    maxWidth: "280px",
    lineBreak: "anywhere",
  };

  const nameStyle = {
    margin: "0",
    fontFamily: "Tondo, Helvetica Neue, Helvetica, Arial, sans-serif",
  };

  function handleChange(func, value) {
    func(value);
  }


  useEffect(() => {

    let tenants = localStorage.getItem(TENANTS)

    if (typeof tenants === "undefined" || tenants.length === 0) {
      setResponse({ msg: "Seems Like you don't have sufficient access", isError: true })
      return;
    }

    if (typeof tenants != String)
      tenants = tenants.split(',')

    if (clientNameList.length === 0 && tenants.length !== 0) {
      setClientName(`clientName=${tenants[0]}`)
      setClientNameList([...tenants])
    }


    if (typeof clientName === "undefined" || clientName === "") {
      return;
    }

    storeClientNameInMemory(clientName.split('=')[1]);

    getOfferIdsList({clientName, offerId})
    .then(res=>{
      setAdsOfferIdBlacklistedList(res.data);
      const uniqueKeys = [];
      res.data.map(blacklistedOffer => {
        if (uniqueKeys.indexOf(blacklistedOffer.offerId) === -1) {
          uniqueKeys.push(String(blacklistedOffer.offerId))
        }
        return 0
      })
      setOfferIdsList(uniqueKeys);
      setResponse({isError:false, msg:""})
    })
    .catch(err=>{
      setAdsOfferIdBlacklistedList([])
      let msg = err && err.response && err.response.data ?err.response.data.error : "Error fetching Blacklisted Offers";
      setResponse({isError:true, msg:msg})
    })
    return () => {
      
    }
  }, [offerId , clientName]);

  function toggleModal(title = '', content = '', callback, flatten = false){
    setModal({
        isOpen : !modal.isOpen,
        title : title,
        content : content,
        flatten,
        didMount : callback
    })
  }


  function initDeleteOfferId(id) {
    const confirmation = window.confirm('Are you sure you want to delete?');

    if(confirmation){
        deleteOfferId(id)
        .then( response => {
          let existingOfferIds = adsOfferIdBlacklistedList.filter(offerId => (offerId.id !== id));
            setAdsOfferIdBlacklistedList(existingOfferIds)
        })
        .catch( err => {
          let msg = err && err.response && err.response.data ? err.response.data.error : "Unable to Delete";
          setResponse({msg:msg, isError:true})
        })
    }
  }


  function renderBlacklistedOfferId(content,index ){
    return (
      <div className={`divTableRow`} key={content.id+index}>
        <div className="divTableCell" style={cellStyle}>
          <pre style={nameStyle}>{content.offerId}</pre>
        </div>
        <div className="divTableCell" style={cellStyle}>
          <pre style={nameStyle}>{content.type}</pre>
        </div>
        <div className="divTableCell" style={cellStyle}>
          <span 
          className="text-info underline cursor-pointer"
          onClick={() => toggleModal("Offer Id Blacklisted CP Details", content, null, true)}>View</span> 
          &emsp;
          <Link to={'/editBlacklistedOfferIds/' + content.id} className="text-warning underline">Edit</Link>
          {/* &emsp; */}
          <span
            className="text-info underline cursor-pointer"
            onClick={() => toggleModal("Blacklisted offer Ids Audits",
              <AuditGroup id={content.id} getAudits={getBlackListedOfferIdsAuditsById} />
            )}
          >Audits</span>
          <span 
          className="text-danger underline cursor-pointer"
          onClick={()=>initDeleteOfferId(content.id)}
          >Delete</span> 
          &emsp;
        </div>
      </div>
    );
  }
 
  return (
    <>
      {modal.isOpen && 
      <Modal 
          flatten={modal.flatten}
          title={modal.title} 
          btnHandler={toggleModal}
          closeTrigger={toggleModal}
          content={modal.content}
          didMount={modal.didMount}
      >
      </Modal>}
      <div>
       <div className="m-0 mt-30 mr-20">
          <div className="row">
            <div className="col-sm-4">
              <fieldset className="pl-20">
                <label className="fs-14 color-dark-gray">Search Offer Id</label>
                <Typeahead
                  id="type-search"
                  onChange={e => handleChange(setOfferId, e[0])}
                  options={offerIdsList}
                />
              </fieldset>
            </div>
            
            <div className="col-sm-4">
              <fieldset className="pl-20">
                <label className="fs-14 color-dark-gray">Client Name</label>
                <form>
                  <select
                    name='clientName'
                    id='clientName'
                    value={clientName}
                    onChange={e => handleChange(setClientName, e.target.value)}
                    className="fs-16" >
                    {clientNameList.map(clientName =>
                      <option
                        key={clientName}
                        value={`clientName=${clientName}`}>
                        {clientName}
                      </option>)}
                  </select>
                </form>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
     
      <div className="row m-0 mt-0 mr-20">
        <div className="row m-0 mt-0 mb-20">
          <div className="col-md-12">
          <h5 className="h5 text-center" style={{"textAlign":"center"}}>Blacklisted CPs Offer Ids</h5>
            <div className="divTable divTableHover mt-20">
              <div className="divTableHeading">
                <div className="divTableRow">
                  <div className="divTableHead">Offer Id</div>
                  <div className="divTableHead">Ad Type</div>
                  <div className="divTableHead">Actions</div>
                </div>
              </div>
              <div className="divTableBody">
                {adsOfferIdBlacklistedList && 
                adsOfferIdBlacklistedList.map((offerId, index)=>renderBlacklistedOfferId(offerId, index))}
              </div>
            </div>
          </div>
        </div>  
      </div>
      <div className="row m-0 mt-30 mr-20 vertical-text-center">
        <div className="col-md-9 text-center">
          <div className={response.isError ? "text-danger" : "text-success"}>
            <b>
              <h4>{response.msg}</h4>
            </b>
          </div>
        </div>
      </div>
    </>
  )
}

export default ViewBlackListedOfferIds
